import {Box, RelativeTime} from '@primer/react'
import {LABELS} from '../constants/labels'

export type MilestoneDescriptionProps = {
  closed: boolean
  closedAt?: string | null
  dueOn?: string | null
  progressPercentage: number
  showProgressPercentage?: boolean
}

export const MilestoneDescription = ({
  closed,
  closedAt,
  dueOn,
  progressPercentage,
  showProgressPercentage = false,
}: MilestoneDescriptionProps) => {
  const isPastDate = dueOn ? new Date(dueOn) < new Date() : false
  const date = closed ? closedAt : dueOn

  return (
    <Box sx={{color: isPastDate && !closed ? 'danger.fg' : 'fg.subtle'}}>
      {getMilestoneDescriptionLabel({isPastDate, closed, dueOn})}
      &nbsp;
      {date && isValidDate(date) && (
        <RelativeTime
          date={new Date(date)}
          day={'numeric'}
          month={'long'}
          year={'numeric'}
          tense={isPastDate || closed ? 'past' : 'auto'}
          format={'auto'}
        />
      )}
      {progressPercentage && showProgressPercentage ? LABELS.milestones.progressPercentage(progressPercentage) : ''}
    </Box>
  )
}

const getMilestoneDescriptionLabel = ({
  isPastDate,
  closed,
  dueOn,
}: {
  isPastDate: boolean
  closed: boolean
  dueOn?: string | null
}) => {
  if (closed) return LABELS.milestones.milestoneClosed
  if (isPastDate) return LABELS.milestones.pastDue
  if (!dueOn || (dueOn && !isValidDate(dueOn))) return LABELS.milestones.noDueDate
  return LABELS.milestones.milestoneDue
}

const isValidDate = (dateString: string): boolean => {
  const date = new Date(dateString)
  return !isNaN(date.getTime())
}

try{ MilestoneDescription.displayName ||= 'MilestoneDescription' } catch {}